import { render, staticRenderFns } from "./DiscountCode.vue?vue&type=template&id=1066d3c2&scoped=true&"
import script from "./DiscountCode.vue?vue&type=script&lang=ts&"
export * from "./DiscountCode.vue?vue&type=script&lang=ts&"
import style0 from "./DiscountCode.vue?vue&type=style&index=0&id=1066d3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1066d3c2",
  null
  
)

export default component.exports